import React, { use, useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
    Card,
    CardBody,
    Form,
    Modal,
    ModalBody,
    Input,
    FormGroup,
    ModalHeader,
    Button,
    Label,
    FormFeedback,
    Row,
    Col,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import LeadTable from "./LeadTable"
import Flatpickr from "react-flatpickr";
import LeadCreateModal from "components/Common/LeadCreateModal"
import { dateFormat, formatDateToISO } from "pages/Common"
import FollowupDetails from "./FollowupDetails"
import ErrorModel from "common/errorModel/errorModel"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"

let userData = []
function LeadList() {
    document.title = `Leads | Raja Rani Couture`
    let { pathname } = useLocation()
    let { state } = useLocation()
    const { deleteApi, getApi, postApi, putApi } = useApi()

    const navigate = useNavigate()

    // useStates
    const [modal, setModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [tableData, setTableData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [screenLoad, setScreenLoad] = useState(false)
    const [searchText, setSearchText] = useState("")
    const [totalRecords, setTotalRecords] = useState(0)
    const [displayStart, setDisplayStart] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [isEdit, setIsEdit] = useState(false)
    const [editData, setEditData] = useState()
    const [dateDisble, setdateDisble] = useState(state?.date ? true : false)
    const [date, setdate] = useState([new Date(), new Date()])
    const [leadStatus, setLeadStatus] = useState(state?.status || 0)
    const [followUpId, setFollowUpId] = useState(0)
    const [followUpDetail, setFollowUpDetail] = useState()
    const [viewFollowupModal, setViewFollowupModal] = useState(false)
    const [followDetailId, setfollowDetailId] = useState(0)
    const [leadId, setLeadId] = useState(0)
    const [leadTypeFilterValue, setLeadTypeFilterValue] = useState(0)
    const [selectedUser, setSelectedUser] = useState({
        label: "Select User",
        value: 0,
    })
    const [leadType, setLeadType] = useState([])
    const [users, setUsers] = useState([])
    const [isMobile, setisMobile] = useState(window.innerWidth < 768)
    const [dateFilter, setDateFilter] = useState(state?.followup ? false : true)

    // filter data for task-title
    const filterData = textFilter => {
        setSearchText(textFilter == undefined ? '' : textFilter)
    }

    useEffect(() => {

        getApi('User/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                userData = (data)
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                }));
                setUsers(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })

        getApi('Lead/type/lookup').then(({ data, status }) => {
            if (status === 200) {
                setLeadType(data)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    // pageSize function
    const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
        setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
        setSearchText(serchValue == undefined ? "" : serchValue)
        setRowsPerPage(pageSize)
    }

    // task-title list api
    const LeadListApi = () => {
        setIsLoading(true)
        setScreenLoad(true)
        postApi("Lead/list", {
            status: parseInt(leadStatus),
            fromDate: !dateDisble ? null : date[0] ? dateFormat(
                date[0],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            toDate: !dateDisble ? null : date[1] ? dateFormat(
                date[1],
                "yyyy-MM-dd"
            ) : new Date().toISOString().slice(0, 10),
            userId: parseInt(selectedUser.value),
            LeadType: parseInt(leadTypeFilterValue),
            displayStart: displayStart,
            pageSize: rowsPerPage,
            searchText: searchText.trim(),
            sortColumn: "",
            sortOrder: "",
            isCreatedDate: dateFilter,
        }).then(({ data, status }) => {
            if (status === 200) {
                setTableData(data.LeadList)
                setTotalRecords(data.TotalRecords)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
            setIsLoading(false)
            setScreenLoad(false)
        })
    }

    // task-title list api useEffect
    useEffect(() => {
        if (date[1] != undefined) {
            LeadListApi()
        }
    }, [searchText, displayStart, rowsPerPage, leadStatus, date, dateDisble, leadTypeFilterValue, selectedUser, dateFilter])


    // Create task-title handler
    const handleLeadClick = () => {
        toggle()
        setIsEdit(false)
    }

    const FollowupValidation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Status: followUpDetail ? (followUpDetail.Status == 1 ? 2 : followUpDetail.Status) : 0,
            NextFollowup: '',
            Remark: "",
        },
        validationSchema: Yup.object({
            Status: Yup.number().required("The status is required"),
            Remark: Yup.string().required("The remark is required"),
        }),
        onSubmit: values => {
            setIsLoading(true)
            postApi("Lead/followup", {
                id: followUpId,
                status: parseInt(values.Status),
                NextFollowup: formatDateToISO(date),
                comment: values.Remark,
            }).then(({ data, status }) => {
                setIsLoading(false)
                if (status === 200) {
                    toggleFollowUp()
                    LeadListApi()
                    FollowupValidation.handleReset()
                    setdate(new Date())
                    toast.success("Update successfully", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        },
    })

    // popup box handler
    const toggle = () => {
        setModal(!modal)
    }

    const toggleFollowUp = () => {
        setModal1(!modal1)
        FollowupValidation.handleReset()
        setdate(new Date())
    }

    const handleEditLead = (data) => {
        setEditData(data)
        setLeadId(data.Id)
        setIsEdit(true)
        toggle()
    }

    const handleDelete = (Id) => {
        setIsLoading(true)
        if (Id) {
            DeleteModel.confirmDeleteInquiry({
                title: "Are you sure? ",
                text: "You want to delete this lead permanently? ",
                isMobile,
            }).then(response => {
                if (response == true) {
                    deleteApi(`Lead/delete?id=${Id}`).then(
                        ({ data, status }) => {
                            if (status === 200) {
                                const updatedArray = tableData
                                    .map(obj => (obj.Id !== Id ? obj : null))
                                    .filter(Boolean)
                                setTableData(updatedArray)
                                toast.success("Lead deleted successfully", {
                                    style: {
                                        fontSize: "15px",
                                    },
                                })
                            } else {
                                ErrorModel.errormodel({
                                    title: "Verify Lead",
                                    text: data,
                                })
                            }
                            setIsLoading(false)
                        }
                    )
                } else {
                    setIsLoading(false)
                }
            })
        }
    }

    const handleFollowUp = (Id, data) => {
        setFollowUpDetail(data)
        setFollowUpId(Id)
        toggleFollowUp()
    }

    const followModel = id => {
        setViewFollowupModal(!viewFollowupModal)
        setfollowDetailId(id)
    }

    const handleByLeadValue = (changeValue, id) => {
        setLeadId(id)
        DeleteModel.confirmDeleteInquiry({
            title: "Are you sure? ",
            text: "You want to assign this lead? ",
            isMobile,
        }).then(response => {
            if (response == true) {
                postApi("Lead/assign-lead", {
                    LeadId: id,
                    HandleBy: parseInt(changeValue),
                }).then(({ data, status }) => {
                    if (status === 200) {
                        LeadListApi()
                    } else {
                        LeadListApi()
                        toast.error(data, {
                            style: {
                                fontSize: "15px",
                            },
                        })
                    }
                })
            } else {
                LeadListApi()
                setIsLoading(false)
            }
        })
    }

    // table headers & accessor
    const columns = useMemo(
        () => [
            {
                Header: "Name",
                accessor: "Name",
                Cell: ({ value, row }) => (
                    <a
                        className="text-primary"
                        onClick={() => followModel(row.original.Id)}
                    >
                        {value}
                    </a>
                ),
            },
            {
                Header: "Contact#",
                accessor: "ContactNo",
                width: "7%"
            },
            {
                Header: "Status",
                accessor: "Status",
                width: "6%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Status == 1 ? "Lead" : row.original.Status == 2 ? "Followup" : row.original.Status == 3 ? "Convert" : "Fail"}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Lead Type",
                accessor: "LeadTypeName",
                width: "8%"
            },
            {
                Header: "Address",
                accessor: "Address",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Address}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Remark",
                accessor: "Remark",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Remark}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Next Followup",
                accessor: "NextFollowup",
                width: "9%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.NextFollowup == null
                            ? "N/A"
                            : dateFormat(row.original.NextFollowup.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Comment",
                accessor: "Comment",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "wrap" }}>
                                {row.original.Comment == null ? "N/A" : row.original.Comment}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Created By",
                accessor: "CreatedByName",
                width: "9%",
                Cell: ({ row }) => {
                    return (
                        <>
                            <div style={{ textWrap: "" }}>
                                {row.original.CreatedByName}
                            </div>
                        </>
                    )
                },
            },
            {
                Header: "Created On",
                accessor: "CreatedOn",
                width: "8%",
                Cell: ({ row }) => (
                    <p className=" mb-0">
                        {row.original.CreatedOn == null
                            ? "N/A"
                            : dateFormat(row.original.CreatedOn.split("T")[0], "dd-MM-yyyy")}
                    </p>
                ),
            },
            {
                Header: "Handle By",
                accessor: "HandleBy",
                width: "13%",
                Cell: ({ row }) => {
                    return (
                        <>
                            {row.original.HandleBy > 0 ? row.original.HandleByName :
                                <Input
                                    type="select"
                                    bsSize="sm"
                                    id="validationCustom01"
                                    className="form-control-sm"
                                    name="Handleby"
                                    onChange={e => {
                                        handleByLeadValue(e.target.value, row.original.Id)
                                    }}
                                    defaultValue={row.original.HandleBy}
                                    disabled={row.original.HandleBy > 0}
                                // value={handleByValue}
                                >
                                    <option value={0}>Select User</option>
                                    {userData.map((item, index) => {
                                        return (
                                            <option key={index} value={item.Key}>
                                                {item.Value}
                                            </option>
                                        )
                                    })}
                                </Input>
                            }
                        </>
                    )
                }
            },
            {
                Header: () => (
                    <div
                        style={{
                            textAlign: "center",
                        }}
                    >
                        Action
                    </div>
                ),
                width: "8%",
                accessor: "action",
                disableFilters: true,
                Cell: ({ row }) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-bullhorn"
                                    style={{ color: "#90499c", cursor: "pointer" }}
                                    id={`followuptooltip${row.original.Id}`}
                                    onClick={() => handleFollowUp(row.original.Id, row.original)}
                                ></i>
                                <span className="mytext">Followup</span>
                            </li>
                            <li className="mytooltip">
                                <i
                                    className=" fs-6 fas fa-edit btn-edit"
                                    id={`edittooltip${row.original.Id}`}
                                    onClick={() => handleEditLead(row.original)}
                                ></i>
                                <span className="mytext">Edit</span>
                            </li>

                            <li className="mytooltip">
                                <i
                                    className="fs-6 fas fa-trash-alt btn-delete"
                                    id={`deletetooltip${row.original.Id}`}
                                    onClick={() => handleDelete(row.original.Id)}
                                ></i>
                                <span className="mytext">Delete</span>
                            </li>
                        </ul>
                    )
                },
            },
        ],
        [tableData]
    );

    function writeDataToExcel() {
        if (!dateDisble) {
            toast.error("Please Select date", {
                icon: "⚠️",
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            setIsLoading(true)
            let header = ["Name", "Contact#", "Status", "Lead Type", "Handle By", "Address", "Remark", "Next Followup", "Comment", "Created On"];
            const mainTitle = "Leads";
            const widthObj = [{
                Key: "A",
                Value: 20,
            },
            {
                Key: "B",
                Value: 12,
            },
            {
                Key: "C",
                Value: 10,
            },
            {
                Key: "D",
                Value: 13,
            },
            {
                Key: "E",
                Value: 15,
            },
            {
                Key: "F",
                Value: 30,
            },
            {
                Key: "G",
                Value: 25,
            },
            {
                Key: "H",
                Value: 18,
            },
            {
                Key: "I",
                Value: 20,
            },
            {
                Key: "J",
                Value: 13,
            },
            ]
            const extention = "Leads.xlsx"
            let excelSheetData = []

            postApi("Lead/list", {
                status: parseInt(leadStatus),
                fromDate: !dateDisble ? null : date[0] ? dateFormat(
                    date[0],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                toDate: !dateDisble ? null : date[1] ? dateFormat(
                    date[1],
                    "yyyy-MM-dd"
                ) : new Date().toISOString().slice(0, 10),
                userId: parseInt(selectedUser.value),
                LeadType: parseInt(leadTypeFilterValue),
                displayStart: displayStart,
                pageSize: 100000,
                searchText: searchText.trim(),
                sortColumn: "",
                sortOrder: "",
                isCreatedDate: dateFilter,
            }).then(({ data, status }) => {
                if (status === 200) {
                    for (let index = 0; index < data?.LeadList?.length; index++) {
                        let dataObj = {
                            Name: data?.LeadList[index].Name,
                            ContactNo: data?.LeadList[index].ContactNo,
                            Status: data?.LeadList[index].Status == 1 ? "Lead" : data?.LeadList[index].Status == 2 ? "Followup" : data?.LeadList[index].Status == 3 ? "Convert" : "Fail",
                            LeadTypeName: data?.LeadList[index].LeadTypeName,
                            HandleByName: data?.LeadList[index].HandleByName ? data?.LeadList[index].HandleByName : "N/A",
                            Address: data?.LeadList[index].Address,
                            Remark: data?.LeadList[index].Remark,
                            NextFollowup: data?.LeadList[index].NextFollowup == null
                                ? "N/A"
                                : dateFormat(data?.LeadList[index].NextFollowup, "dd-MM-yyyy"),
                            Comment: data?.LeadList[index].Comment == null ? "N/A" : data?.LeadList[index].Comment,
                            CreatedOn: data?.LeadList[index].CreatedOn == null
                                ? "N/A"
                                : dateFormat(data?.LeadList[index].CreatedOn, "dd-MM-yyyy"),
                        }
                        excelSheetData.push(dataObj)
                    }
                    var fields = Object.keys(excelSheetData[0]);
                    var sheetData = excelSheetData.map(function (row) {
                        return fields.map(function (fieldName) {
                            return row[fieldName];
                        });
                    });
                    sheetData.unshift(header);
                    exportDataExcel(sheetData, mainTitle, widthObj, extention)
                } else {
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
            setIsLoading(false)
        }
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                {screenLoad && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].parent}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                    link={breadcrumbs[pathname].parentLink}
                />
                <Card>
                    <CardBody>
                        <LeadTable
                            columns={columns}
                            data={tableData}
                            isGlobalFilter={true}
                            isAddLeadList={true}
                            handleLeadClick={handleLeadClick}
                            customPageSize={10}
                            className="custom-header-css"
                            filterData={filterData}
                            isLoading={isLoading}
                            TotalRecords={totalRecords}
                            pagePerSize={pagePerSize}
                            dateDisble={dateDisble}
                            setdateDisble={setdateDisble}
                            date={date}
                            setLeadStatus={setLeadStatus}
                            leadStatus={leadStatus}
                            setdate={setdate}
                            leadType={leadType}
                            leadTypeFilterValue={leadTypeFilterValue}
                            setLeadTypeFilterValue={setLeadTypeFilterValue}
                            users={users}
                            selectedUser={selectedUser}
                            setSelectedUser={setSelectedUser}
                            writeDataToExcel={writeDataToExcel}
                            setScreenLoad={setScreenLoad}
                            LeadListApi={LeadListApi}
                            setDateFilter={setDateFilter}
                            dateFilter={dateFilter}
                        />

                        <LeadCreateModal
                            modal={modal}
                            toggle={toggle}
                            isEdit={isEdit}
                            LeadListApi={LeadListApi}
                            editData={editData}
                            leadId={leadId}
                        />

                        <Modal
                            isOpen={modal1}
                            toggle={toggleFollowUp}
                            centered={true}
                            size="sm"
                        >
                            <div className="modal-content">
                                <ModalHeader toggle={toggleFollowUp} tag="h5">
                                    Followup
                                </ModalHeader>
                                <ModalBody>
                                    <Form
                                        onSubmit={e => {
                                            e.preventDefault()
                                            FollowupValidation.handleSubmit()
                                            return false
                                        }}
                                        onReset={e => {
                                            e.preventDefault
                                            FollowupValidation.handleReset()
                                            setdate(new Date())
                                            return false
                                        }}
                                    >
                                        <FormGroup className="mb-2">
                                            <Label htmlFor="formrow-InputState" className="required">
                                                Status
                                            </Label>
                                            <Input
                                                type="select"
                                                bsSize="sm"
                                                id="formrow-InputState"
                                                className="form-control"
                                                name="Status"
                                                onChange={FollowupValidation.handleChange}
                                                onBlur={FollowupValidation.handleBlur}
                                                value={FollowupValidation.values.Status}
                                                invalid={
                                                    FollowupValidation.touched.Status && FollowupValidation.errors.Status
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value={2}>Followup</option>
                                                <option value={3}>Convert</option>
                                                <option value={4}>Fail</option>
                                            </Input>
                                            {FollowupValidation.touched.Status && FollowupValidation.errors.Status ? (
                                                <FormFeedback type="invalid">
                                                    {FollowupValidation.errors.Status}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>
                                        <FormGroup className="mb-2">
                                            <div>
                                                <Label htmlFor="FollowupValidation1Custom01">
                                                    Next Followup Date
                                                </Label>
                                                <div className="d-flex date-after" >
                                                    <Flatpickr
                                                        className="form-control d-block flatpicker-date"
                                                        placeholder="dd-MM-yyyy"
                                                        options={{
                                                            // enableTime: true,
                                                            dateFormat: "d-m-Y",
                                                            disableMobile: true
                                                        }}
                                                        value={date}
                                                        onChange={(e) => { setdate(e) }}
                                                    />
                                                </div>
                                            </div>
                                        </FormGroup>

                                        <FormGroup className="mb-2">
                                            <Label htmlFor="FollowupValidationCustom03" className="required">
                                                Remark
                                            </Label>
                                            <Input
                                                name="Remark"
                                                placeholder="type your remark here"
                                                type="textarea"
                                                row={2}
                                                className="form-control-sm"
                                                onChange={FollowupValidation.handleChange}
                                                onBlur={FollowupValidation.handleBlur}
                                                value={FollowupValidation.values.Remark || ""}
                                                invalid={
                                                    FollowupValidation.touched.Remark && FollowupValidation.errors.Remark
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {FollowupValidation.touched.Remark && FollowupValidation.errors.Remark ? (
                                                <FormFeedback type="invalid">
                                                    {FollowupValidation.errors.Remark}
                                                </FormFeedback>
                                            ) : null}
                                        </FormGroup>

                                        <div className="text-end">
                                            <Button
                                                color="secondary"
                                                className="btn btn-primary me-2 btn-sm "
                                                type="reset"
                                            >
                                                Reset
                                            </Button>

                                            {isLoading ? (
                                                <button type="button" className="btn btn-primary btn-sm">
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="submit"
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </ModalBody>
                            </div>
                        </Modal>

                        <Modal
                            isOpen={viewFollowupModal}
                            toggle={followModel}
                            centered={true}
                            size="small"
                        >
                            <div className="modal-content">
                                <ModalHeader className="text-centre" toggle={followModel} tag="h5">
                                    FollowUp
                                </ModalHeader>
                                <ModalBody>
                                    <FollowupDetails id={followDetailId} />
                                </ModalBody>
                            </div>
                        </Modal>

                    </CardBody>
                </Card>
            </div>
        </div>
    )
}
LeadList.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
    onFilterChange: PropTypes.func,
}

export default LeadList
